import React, { useContext } from 'react';
import EDView from '../../../../../../BaseComponents/View/EDView';
import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { GridContext } from '../../../../../GridContext';
export interface IObjektVyProps {
  autoFit?: boolean;
}

const useStyles = makeStyles()(
  (theme: Theme) =>
    ({
      outerContainer: {
        boxSizing: 'border-box',
        margin: 0,
        display: 'flex',
        flexFlow: 'row wrap',
        justifyContent: 'flex-start',
        [theme.breakpoints.only('xs')]: {
          flexDirection: 'column',
        },
      },
      gridOuterContainer: {
        boxSizing: 'border-box',
        margin: 0,
        width: '100%',
        display: 'grid',
        gridTemplateColumns: `repeat(auto-fill, minmax(${theme.spacing(
          27
        )}, 1fr))`,
        gridGap: theme.spacing(1, 1),
        [theme.breakpoints.only('xs')]: {
          width: 'auto',
          marginTop: theme.spacing(1),
          gridGap: theme.spacing(0.5),
        },
      },
      autoFit: {
        gridTemplateColumns: `repeat(auto-fit, minmax(${theme.spacing(
          27
        )}, 1fr))`,
      },
      paddingBottom: {
        paddingBottom: `${theme.spacing(1)}`,
      },
    } as const)
);

/**
 * Komponent som visar en grupp av fält, med möjlighet att välja mellan flex och grid
 */
export const ObjektVyFaltLista: React.FC<
  React.PropsWithChildren<IObjektVyProps>
> = props => {
  const { classes, cx } = useStyles();
  const gridContext = useContext(GridContext);

  return (
    <EDView
      className={cx({
        [classes.gridOuterContainer]: gridContext.inGrid,
        [classes.outerContainer]: !gridContext.inGrid,
        [classes.autoFit]: gridContext.inGrid && props.autoFit,
        [classes.paddingBottom]: true,
      })}
    >
      {props.children}
    </EDView>
  );
};
